<template>
    <div class="tooltip-position">
      <template>
        <div class="custom-tooltip">
          <div class="custom-tooltip-row">
            <span class="custom-tooltip-row-start-span fw-bold">
              {{ tooltipTextProp }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: "Tooltip",
    props: {
      tooltipTextProp:     { type: String,   required: false, default: '' },
    },
    data() {
      return {
      };
    },
    methods: {
    },
  };
  </script>
  
  <style scoped lang="scss">
.tooltip-position {
  position: relative;
  cursor: pointer;
}

.custom-tooltip {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 500;
  white-space: normal;
  max-width: 280px;
  overflow-wrap: break-word;
  word-break: break-word;

  transform: translate(-100%, -30%);

  .custom-tooltip-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }

    & > span {
      width: 100%;
    }

    .custom-tooltip-row-left-span {
      text-align: left;
    }
    .custom-tooltip-row-right-span {
      margin-left: 8px;
      text-align: right;
    }
    .custom-tooltip-row-start-span {
      text-align: start;
    }
  }
}

  </style>
  